import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  date: string;
  rating?: number;
  author: string;
  readTime: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  image,
  date,
  rating,
  author,
  readTime,
}: ArticleCardProps) {
  const categoryNames: Record<string, string> = {
    rpg: 'RPG',
    avg: 'AVG',
    slg: 'SLG',
    act: 'ACT',
    puzzle: 'Puzzle',
    sandbox: 'Sandbox',
    simulation: 'Simulation',
    doujin: 'Doujin',
    news: '资讯',
  };

  return (
    <Link
      to={`/article/${slug}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
    >
      <div className="relative w-full sm:w-48 h-32 flex-shrink-0 overflow-hidden rounded-md">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap mb-1.5">
          <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
            {categoryNames[category] || category}
          </span>
          {rating && (
            <span className="flex items-center gap-0.5 text-xs text-foreground-500">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              {rating}
            </span>
          )}
        </div>
        <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-2">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400 flex-wrap">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}